import React from 'react';

import Modal from '.';
import { ModalBody } from './stylesV2';

class ModalNew extends React.Component {
    constructor(props){
        super(props);
    }

    styles = {
        control: provided => ({
            ...provided,
            padding: "15px"
        })
    };

    render(){
        return(   
            <Modal
                {...this.props}
                align='center' // center, end, start
                justify='center' // center, end, start
                responsive
            >
                <ModalBody marginBottom={this.props.marginBottom}>
                    {this.props.children}
                </ModalBody>
            </Modal>

        );
    }
}
export default ModalNew;